import { useNavigate } from 'react-router-dom';
import { useSurveyContext } from '../../context/SurveyContext';
import Container from '../../components/Layout/Container';
import common from './Common.module.scss';
import local from './SurveyEnd.module.scss';
import { Button } from 'antd';

// Listed in survey order; only the sections actually answered are mentioned.
const SECTION_SUMMARIES: Record<string, string> = {
  sec_limiting_beliefs: 'your limiting beliefs',
  sec_core_archetypes: 'your core personality archetypes',
  sec_career_assessment: 'suitable career paths',
};

const formatList = (items: string[]): string => {
  if (items.length < 2) return items[0] ?? '';
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
};

const SurveyEnd = () => {
  const navigate = useNavigate();
  const { surveyState, resetSurvey } = useSurveyContext();

  const completedSummaries = Object.keys(SECTION_SUMMARIES)
    .filter(sectionId => surveyState.answers?.[sectionId])
    .map(sectionId => SECTION_SUMMARIES[sectionId]);

  const reportSummary = completedSummaries.length > 0
    ? formatList(completedSummaries)
    : 'the sections you completed';

  const handleBackToHome = () => {
    resetSurvey();
    navigate('/');
  };

  return (
    <div className={`${common.surveyWrapper} ${local.surveyEndWrapper}`}>
      <Container>
        <div className={common.surveyTextSection}>
          <h1 className={local.surveyEndTitle}> 🎉 You Did It! </h1>
          <div className={`${common.surveyParagraphs} ${local.surveyEndText}`}>
            <p>Great job for completing your self-discovery assessment!<br />
            We’re now analyzing your answers to craft a personalized report that reflects {reportSummary}.</p>
            <p>This may take a few minutes to process.</p>
            <p>✨ Your report will be sent to your email shortly. Keep an eye on your inbox!</p>
            <p>Please check your spam folder if you have not received the report within 10 minutes.</p>
          </div>
          <div className={common.surveyButtonWrapper}>
             <Button 
               type="primary" 
               className={common.surveyButton} 
               onClick={handleBackToHome}
               block
             >
               Back to Home Page
             </Button>
          </div>
         </div>
      </Container>
    </div>
  );
};

export default SurveyEnd;
